// Detects text layers that are garbage (e.g. a scanner's OCR of an upside-down page).
// Keep in sync with backend text_readability.py.
const WORDS = `the and of to in for on with at by from is are was were be been has have had not no yes or as an a
it its this that these those which who whom what when where how all any each per than then there their they them
we you your our he she his her him patient name date birth address phone tel email number ref reference hospital
clinic doctor dr gp nurse surgery practice nhs consultant department ward letter dear sincerely regards summary
report result results test tests range normal abnormal high low units unit value values sample specimen collected
received reported requested comment comments note notes history medical medication medications dose daily twice
tablet tablets mg ml mcg kg cm mmol mol umol nmol pmol iu blood serum plasma urine full count cell cells white red
haemoglobin hemoglobin platelets platelet cholesterol hdl ldl triglycerides glucose hba1c ferritin iron vitamin
folate thyroid tsh free t4 t3 liver kidney renal function alt ast ggt alp bilirubin albumin protein creatinine urea
egfr sodium potassium chloride calcium magnesium phosphate crp esr psa testosterone oestradiol estradiol cortisol
insulin heart rate pressure systolic diastolic ecg bmi weight height pain chest diagnosis problem problems active
past allergies allergy review follow up appointment referral discharge admission scan xray x-ray mri ct ultrasound
left right upper lower acute chronic type diabetes asthma hypertension infection examination plan advice reports
year years month months week weeks day days time male female age sex page of total only also may will should
please see further current previous recent repeat started stopped prescribed issued known nil none other
el la los las de del y en un una con por para es son que se al su sus paciente fecha resultado resultados
valor valores sangre análisis analisis informe médico medico hospital nombre edad mes año`.split(/\s+/);
const KNOWN = new Set(WORDS);

// Zero-width, bidi controls, word joiners, BOM, soft hyphen, Unicode "tag" characters (ASCII smuggling).
const INVISIBLE = /[\u00ad\u180e\u200b-\u200f\u202a-\u202e\u2060-\u2064\u2066-\u206f\ufeff]|\udb40[\udc00-\udc7f]/g;
export const stripInvisibleChars = (text) => (text || '').replace(INVISIBLE, '');

export const textLooksReadable = (text) => {
  const tokens = (text || '').toLowerCase().match(/[a-zà-ÿ]{2,}/g) || [];
  if (tokens.length < 30) return true;
  const known = tokens.filter(t => KNOWN.has(t)).length;
  return known / tokens.length >= 0.15;
};

// For on-device photo OCR: Tesseract garbage is mostly symbols and stray letters.
// Meaningful tokens are words of 3+ letters or numbers (with . , : / -).
export const ocrTextLooksReadable = (text) => {
  const tokens = (text || '').split(/\s+/).filter(Boolean);
  if (!tokens.length) return false;
  const meaningful = tokens.filter(t => /^[A-Za-zÀ-ÿ]{3,}[.,:;)]?$/.test(t) || /^[(<>~]?\d+([.,:/-]\d+)*[%)]?$/.test(t)).length;
  return meaningful / tokens.length >= 0.5 && textLooksReadable(text);
};
